import {VmView} from 'components'

export default function DefaultFooter() {
  return (
    <VmView className="w-full h-full text-center rounded-lg bg-red1-stripes">
      Footer
    </VmView>
  )
}
